import { NOT_REQUIRED, QUESTION_TYPE, ESCAPE_HTML_COMPONENT } from "constant";
import { Api } from "services/request";

const { QUESTION, OPTION } = ESCAPE_HTML_COMPONENT

// export const _AuthHeaders = () => {
//   const token = process.env.REACT_APP_TOKEN;
//   return {
//     Authorization: `${token}`,
//     "Content-Type": "application/json",
//   };
// };

/**
 * This functions add a count property to each element of an array using index
 * @param {array} questions
 */
export const addCountExcludingBreaker = (questions) => {
  let lastCount = 0;
  return questions.map((question, index) => {
    if (question.type !== QUESTION_TYPE.BREAKER_SCREEN) {
      const updateObj = { ...question, count: lastCount + 1 };
      lastCount++;
      return updateObj;
    }

    return question;
  });
};

/**
 * This function shuffles an array using a randomising algorithm. Currently getting used by MCQ options.
 * @param {array} - array to randomise
 * @return {array} - re-shuffled array
 */
export const shuffleArr = (array) => {
  for (let index = array.length - 1; index > 0; index--) {
    const randIndex = Math.floor(Math.random() * (index + 1));
    [array[index], array[randIndex]] = [array[randIndex], array[index]]
  }
  return array
}

/**
 * Gives questions array without breaker screen question
 * @param {array} questions
 */
export const getQuestionsExcludingBreaker = (questions) => {
  if (!questions) return [];

  return questions.filter(
    (question) => question.type !== QUESTION_TYPE.BREAKER_SCREEN
  );
};

/**
 * Check questions array for speech questions to set microphone permissions.
 * returns NOT_REQUIRED string in case speech type question is not present
 * @param {array} questions
 * @returns {boolean | string}
 */
export const askForMicrophonePermission = async (questions) => {
  const speechTypes = [
    QUESTION_TYPE.SPEECH_SCRIPTED,
    QUESTION_TYPE.SPEECH_SPONTANEOUS,
  ];
  const checkSpeechQuestion = questions.find(({ type }) =>
    speechTypes.includes(type)
  );

  if (!checkSpeechQuestion) return NOT_REQUIRED;

  try {
    await navigator.mediaDevices.getUserMedia({ audio: true });
    return true;
  } catch (error) {
    return false;
  }
};

export const handleCopyPaste = (e) => {
  e.preventDefault();
};

export const handleCopyPasteKeyDown = (e) => {
  if (e.metaKey && (e.key === 'v' || e.key === 'V' || e.key === 'c' || e.key === 'C')) {
    e.preventDefault();
  }
};

export const disableCopyPasteHandlers = {
  onPaste: handleCopyPaste,
  onCopy: handleCopyPaste,
  onKeyDown: handleCopyPasteKeyDown
};

// Grammarly adds its own elements in dom
// Remove these elements  + any others can be added
export const disableGrammarlyExtension = () => {
  const grammarlyElement = document.querySelector('grammarly-desktop-integration');
  const grammarlyPop = document.querySelector('grammarly-popups');
  const grammarlyExt = document.querySelector('grammarly-extension');
  // If the element is found, remove it from the document
  if (grammarlyElement) {
    grammarlyElement.remove();
  }
  if (grammarlyPop) {
    grammarlyPop.remove();
  }
  if (grammarlyExt) {
    grammarlyExt.remove();
  }
};

export const getChatMessage = async ({ promptId, messages, id = "" }) => {
  try {
    // getting chat message reply
    const payload = { messages };
    const chatResponse = await Api.post(`/api/chat-analysis/v1/${promptId}/complete-chat`, payload);
    if (!chatResponse?.success) {
      throw chatResponse;
    }
    // appending the chat message as type assistant to send back
    return [...messages, { type: 'assistant', content: chatResponse.data, ...(id && { id }) }];
  } catch (err) {
    console.error('Error in chat response api: ', err);
    return err;
  }
};

/** HACKS - DO NOT TOUCH WITHOUT CONSEQUENCES */

// Used for pecial characters within the code blocks which are converted to HTML entities.
const escapeHtml = (unsafe) => {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

// Used specifically for PHP code blocks to ensure that the <?php tags are correctly displayed
const unescapeHtmlEntities = (safe) => {
  return safe
    .replace(/&gt;/g, ">")
    .replace(/&lt;/g, "<")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, "\"")
    .replace(/&#039;/g, "'");
};

// Function to parse and escape content inside <code> tags
// Segregation for escaping in Question component and Option component
// This is necessary since question come parsed as html and options (answers) come as plain text
export const parseAndEscapeCode = (text, component = QUESTION) => {
  const parseForQuestionComponent = component === QUESTION;
  const codeRegex = /<code>([\s\S]*?)<\/code>/g;
  let match;
  let lastIndex = 0;
  const parts = [];

  while ((match = codeRegex.exec(text)) !== null) {
    const [fullMatch, codeContent] = match;
    parts.push(text.slice(lastIndex, match.index));
    if (parseForQuestionComponent) parts.push(`<code>${unescapeHtmlEntities(escapeHtml(codeContent))}</code>`);
    else parts.push(`<code>${escapeHtml(codeContent)}</code>`);
    lastIndex = match.index + fullMatch.length;
  }

  parts.push(text.slice(lastIndex));
  let result = parts.join('');

  return result;
};

export const getRandomInRange = (min, max) => Math.floor(Math.random() * (max - min) + min)